import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleEventSMSEnabled } from '../../../actions/draw-edit-actions';
import EventDeskTabLayout from '../EventDeskTabLayout';
import Img from '../../../components/Img';
import {
    getSmsSendingAvailability,
    buildSmsUnavailableMessage,
} from '../../../utils/eventSmsAvailability';

import styles from '../ScheduleTab/scheduleTab.scss';

function NotificationsTab() {
    const { event } = useSelector(({ drawEdit }) => {
        const { event } = drawEdit;
        return { event };
    });

    const dispatch = useDispatch();

    const [isSmsActive, setIsSmsActive] = useState(event.data.smsEnabled);

    const eventDeskNotificationsEnabled = event.data?.enableEventDeskNotifications;

    const smsAvailability = useMemo(() => getSmsSendingAvailability(event?.data), [event?.data]);

    const toggleDisabled = !smsAvailability.canSend;
    const toggleDisabledMessage = toggleDisabled
        ? buildSmsUnavailableMessage(smsAvailability.reason, smsAvailability.cutoffDisplay, true)
        : null;

    const handleSmsClick = () => {
        if (toggleDisabled) {
            return;
        }
        const { id } = event.data;
        const nextActive = !isSmsActive;
        dispatch(toggleEventSMSEnabled(id, nextActive));
        setIsSmsActive(nextActive);
    };

    return (
        <EventDeskTabLayout className={styles.scheduleTab}>
            {(eventDeskNotificationsEnabled && (
                <div className={styles.content}>
                    <h4 className={styles.title} data-testid="draw-edit.notifications.title">
                        Manage Notifications
                    </h4>
                    <div
                        className={`radio-button noselect ${styles.option} ${toggleDisabled ? styles.disabled : ''}`}
                        onClick={handleSmsClick}
                        aria-disabled={toggleDisabled}
                        data-testid="draw-edit.notifications.sms-toggle"
                    >
                        <label>
                            <div className={`checkbox ${isSmsActive ? 'selected' : ''}`}>
                                <div className="checkbox-wrapper">
                                    <div className={`checkbox-check`}><Img src="/img/icons/checkmark-icon.svg" /></div>
                                </div>
                                <div className="radio-button-label">
                                    <div className={styles.label}>
                                        Enable SMS texting to players
                                    </div>
                                </div>
                            </div>
                        </label>
                    </div>
                    {toggleDisabledMessage && (
                        <p
                            className={styles.toggleDisabledMessage}
                            data-testid="draw-edit.notifications.sms-toggle-disabled-message"
                        >
                            {toggleDisabledMessage}
                        </p>
                    )}
                </div>
            ))}
        </EventDeskTabLayout>
    );
}

export default NotificationsTab;
